import { FormHTMLAttributes, forwardRef } from 'react';

type FormProps = FormHTMLAttributes<HTMLFormElement>;

const Form = 
    forwardRef<HTMLFormElement, FormProps>(({ children, ...rest }: FormProps, ref) => (
        <form ref={ref} method="post" {...rest}>
            {children}
        </form>
    ));

Form.displayName = 'Form';

export default Form;